import Vue from 'vue';
import axios from 'axios'

const state = {
    
}

const mutations = {
    
}

const actions = {
    fetchProjectUsers ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_NDA}/fetch/project/users?project_id=${params.project_id}`);
    },
    fetchVendorUsers ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_NDA}/fetch/vendor/users?supplier_id=${params.supplier_id}`);
    },
    getUnmappedHeaders ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_DRM}/unmapped/headers`);
    },
    ndaDecision ({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_NDA}/epc/nda/action`, params);
    },
    fetchPreviewUrls ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_NDA}/nda/preview?file_path=${params.file_path}&nda_id=${params.nda_id}&type=${params.type}&project_id=${params.project_id}`);
    },
    sendSupplierNDA ({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_NDA}/supplier-nda/send`, params);
    },
    async deassociateProjects(_, { project_ids, supplier_ids }) {
        return axios.delete(`${process.env.VUE_APP_API_BIDDER}/suppliers/projects`, {
            data: { project_ids, supplier_ids },
        });
    },
    associateSuppliersToProjects ({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_BIDDER}/suppliers/projects`, params);
    },
    getJobStatus ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_SUPPLIER}/jobs/status?file_process_id=${params.file_process_id}`);
    },
    startExtraction ({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_SUPPLIER}/files/start-extraction`, params);
    },
    checkExtraction ({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_SUPPLIER}/jobs/status`, params);
    },
    headersMapping ({commit}, params){
        return axios.put(`${process.env.VUE_APP_API_SUPPLIER}/files/header-mapping`, params);
    },
getVendorsList(_, { project_id = null, page_no = 1, page_size = 15 } = {}) {
  const pageNo = Number.parseInt(page_no, 10) || 1
  const pageSize = Number.parseInt(page_size, 10) || 15

  // Treat empty string as "no project"
  const hasProject =
    project_id !== null &&
    project_id !== undefined &&
    String(project_id).trim() !== ""

  if (hasProject) {
    return axios.get(`${process.env.VUE_APP_API_BIDDER}/project/information`, {
      params: { project_id, page_no: pageNo, page_size: pageSize },
    })
  }

  return axios.get(`${process.env.VUE_APP_API_SUPPLIER}/suppliers`, {
    params: { page_no: pageNo, page_size: pageSize },
  })
},
    getSupplierInfo(_, { supplier_id } = {}) {
        return axios.get(`${process.env.VUE_APP_API_SUPPLIER}/ndastatus/suppliers`, {
            params: { supplier_id },
        })
    },
    async searchSuppliers(_, { query, project_id, page_no, page_size }) {
        return axios.post(`${process.env.VUE_APP_API_SEARCH}/supplier/search`, {
            query,
            project_id,
            page_no,
            page_size,
        })
    },
    mappingColoumns ({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_SUPPLIER}/files/header-mapping`, params);
    },
    getHeaders ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_SUPPLIER}/files/mapping`);
    },
    getNewHeaders ({commit}, params){
        return axios.get(`${process.env.VUE_APP_API_SUPPLIER}/files/header-mapping?file_process_id=${params.file_process_id}`);
    },
    uploadEpcSignedFile(_, formData) {
        return axios.post(`${process.env.VUE_APP_API_NDA}/file/upload`, formData, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'multipart/form-data'
            },
        })
    },
    uploadFile({commit}, params) {
        let data = new FormData();
        data.append('file', params)
        return axios.post(`${process.env.VUE_APP_API_SUPPLIER}/files/upload`, data, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'multipart/form-data'
            },
            processData: false,
            contentType: false,
        })
    },
    getTemplateFormats({commit}, params) {
        if(params?.bid_type === 'cbe') {
            return axios.get(`${process.env.VUE_APP_API}/template/formats/download?bid_type=${params.bid_type}&type=${params.type}`);
        }else if(params?.type) {
            return axios.get(`${process.env.VUE_APP_API}/template/formats/download?bid_type=${params.active_tab}&item=${params.item}`);
        }
        return axios.get(`${process.env.VUE_APP_API}/template/formats/download?bid_type=${params}`);
    },
    resetState({ commit }) {
        commit('RESET_STATE');
    }
}

const getters = {
    isLoading(state) {
        return state.loading;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
